import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-row flex-wrap gap-1"
}
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["title", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-download" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-flex flex-column justify-content-center w-100 h-100" }
const _hoisted_12 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["title", "onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-copy" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["title", "onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-0",
    columns: this.columns,
    rowPosFactory: this.rowPosFactory,
    rowPosIncrementor: this.rowPosIncrementor,
    items: this.filteredItems
  }, {
    name: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(item.label.name), 1)
    ]),
    reviewCycle: _withCtx(({ item }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.$s(item.reviewCycle.name)), 1)
    ]),
    labelContents: _withCtx(({ item, rowPos, labelContent = _ctx.getLabelContentForRowPos(item, rowPos) }) => [
      (labelContent != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(labelContent.name), 1),
            (labelContent.filename != null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('review.labelContent.list.previewToolTip'),
                  onClick: ($event: any) => (_ctx.openPreview(item, labelContent))
                }, _hoisted_6, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (labelContent.origFilename != null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('review.labelContent.list.downloadToolTip'),
                  onClick: ($event: any) => (_ctx.download(labelContent))
                }, _hoisted_9, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    active: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", null, _toDisplayString(!!(item.label?.active) ? "✓" : "❌"), 1)
      ])
    ]),
    actions: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (this.mayEditLabel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-outline-secondary",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.label.list.editLabel'),
                onClick: ($event: any) => (_ctx.edit(item))
              }, _hoisted_15, 8, _hoisted_13))
            : _createCommentVNode("", true),
          (this.mayEditLabel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-sm",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.label.list.copyToolTip'),
                onClick: ($event: any) => (_ctx.copyLabel(item))
              }, _hoisted_18, 8, _hoisted_16))
            : _createCommentVNode("", true),
          (this.mayEditLabel)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-sm btn-outline-danger",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.label.list.deleteLabel'),
                onClick: ($event: any) => (_ctx.deleteLabel(item))
              }, _hoisted_21, 8, _hoisted_19))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["columns", "rowPosFactory", "rowPosIncrementor", "items"]))
}